var exports = {
  "EA": "Skeleton__O3Oi2q",
  "tJ": "ColumnHeaders__LYvsXb",
  "AW": "ColumnHeader__ggku3d",
  "Sc": "Rows__4a8qUC",
  "fI": "Row__RaDQAo",
  "yz": "RowHeader__e9uwi3",
  "Cp": "Cells__HKT-Ml",
  "fh": "Cell__M7KiS7",
};

module.exports = exports;
